<template>
  <div class="app-main" @click="loseFocus">
    <div class="main">
      <img style="width:100%;display: block;" src="../images/mobile/bg3.jpg" alt="" />
      <div class="sixteen"></div>

      <!-- 下载链接 -->
      <div class="app-load">
        <div class="secret mrn" @click="handleTrackClick('app')">
          <a
            href="https://apps.apple.com/cn/app/%E6%88%BF%E9%97%B4%E7%9A%84%E7%A7%98%E5%AF%863-%E5%A5%B3%E5%9B%A2%E5%9B%9E%E5%BD%92%E5%A4%9C/id6446578284"
            target="_blank"
          >
            <img :src="getSrc(1)" alt="" class="load load1" />
          </a>
        </div>
        <div class="secret">
          <a>
            <img
              :src="getSrc(2)"
              alt=""
              class="load load1"
              @click="showDownloadList"
              data-name="android"
            />
            <ul v-if="downloadListVisible" class="download-list">
              <li v-for="item in downloadData" :key="item.url" @click="handleTrackClick(item.channel)">
                <a v-if="item.channel==='azgf'" :href="item.url"><img :src="item.iconUrl"/></a>
                <a v-else :href="item.url"  target="_blank"><img :src="item.iconUrl"/></a>
              </li>
            </ul>
          </a>
        </div>
      </div>
      <p class="text-tips">*PC版即将上线Steam平台</p>
    </div>
    <div class="app-footer">
      <img class="img" src="../images/mobile/footer.jpg" alt="" />
      <div class="logos">
        <div class="logo logo1"></div>
        <div class="logo logo2"></div>
      </div>
      <div class="address">
        <div class="add-top extra">
          <div class="add-block">
            <a href="#" class="add-text" @click="handleOpen()">联系我们</a>
            <div class="s-line"></div>
          </div>
          <div v-for="(item, index) in links" :key="index" class="add-block">
            <a class="add-text" target="_blank" :href="item.url">{{ item.name }}</a>
            <div class="s-line"></div>
          </div>
        </div>
        <div v-for="(item, index) in textList" :key="index" class="add-top extra">
          <div>{{ item }}</div>
        </div>
      </div>
    </div>
    <div v-if="modalVisible" class="radioModal">
      <div class="radio-main">
        <div class="close" @click="close">
          <img src="../images/common/close.png" alt="" />
        </div>
        <div class="contact">
          <div class="age-text">
            <h2>联系我们</h2>
            <div class="main-block">
              <div class="mess">
                <div v-for="(item, index) in addList" :key="index" class="text">
                  {{ item }}
                </div>
              </div>
              <img src="../images/common/cotact.jpg" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { downloadData } from '../../config/common'
  export default {
    name: 'AppBanner',
    components: {},
    data() {
      return {
        currentIndex: 0,
        modalVisible: false,
        downloadListVisible: false,
        downloadData,
        links: [
          {
            name: '法律声明',
            url: 'https://dc-app.9longe.net/hyqf/legalStatement.html',
          },
          {
            name: '纠纷处理',
            url: 'https://dc-app.9longe.net/hyqf/disputesSettlemen.html',
          },
          {
            name: '家长监护',
            url: 'https://dc-app.9longe.net/hyqf/parentProtect.html',
          },
          {
            name: '隐私政策',
            url: 'https://dc-tfc-hb2.9longe.net:30080/dc-update/audit/document/view?publisher=12564&game=1688&doc_type=privacy_policy&language_code=zh-cn',
          },
          {
            name: '儿童保护',
            url: 'https://dc-app.9longe.net/hyqf/child-protection.html',
          },
          {
            name: '用户协议',
            url: 'https://dc-app.9longe.net/hyqf/license.html',
          },
        ],
        ageList: [
          '1、本游戏是一款玩法简单的解谜类游戏，适用于年满16周岁及以上用户，建议未成年人在家长的监护下使用该游戏产品。',
          '2、本游戏基于架空的故事背景进行，画面色彩鲜明、配乐抒情。游戏内全部角色、剧情为虚构，不会与现实相混淆。游戏以多个房间为关卡设定，玩家进入房间后观察房间情况，通过查看房间内物品了解故事背景和掌握部分线索，房间中每个物品所带来的线索或者谜题都可能是下一个关卡的线索或者破案的关键。通过攻克层层谜题，体验解谜的乐趣，有较强的代入感，最终成功离开房间。游戏中不存在基于文字和语音的陌生人社交系统。',
          '3、根据国家相关要求，本游戏中有用户实名认证系统，未通过实名认证的用户不可进入游戏，认证为未成年人的用户将接受以下管理：',
          '游戏中无任何收费内容。认证为未成年人的用户，仅可在周五、周六、周日及法定节假日每日20时至21时进行游玩，其他时间均不可进入游戏。',
          '4、 本游戏以密室解谜逃脱为主题，玩家通过在各个房间内获取线索和道具，解开场景中的谜题，将故事一步步往前推进，并成功从房间逃脱。通过这一过程，锻炼玩家协调认知的综合能力，增强玩家逻辑分析能力和思维敏捷性。',
        ],
        addList: [
          '联系地址：厦门市软件园三期诚毅北大街62号109单元0786号',
          '联系电话：18030296975',
          '微博：NoFace工作室',
          'taptap：NoFace工作室',
          '微信公众号：NoFace工作室',
        ],
        textList: [
          '投诉地址：ceo@dianchu.com投诉热线：18030296975',
          '健康游戏忠告：抵制不良游戏 拒绝盗版游戏 注意自我保护 谨防受骗上当',
          '适度游戏益脑 沉迷游戏伤身 合理安排时间 享受健康生活',
          '厦门皓月清风网络科技有限公司 ©2022',
          '本公司旗下所运营游戏均适合16周岁以上人群',
          '闽ICP备13010990号 ICP证：闽B2-20160006 闽网文[2018]6950-302号',
          '闽公网安备35020302001590号',
        ]
      }
    },
    methods: {
      getSrc(index) {
        return index === 2
          ? require(`../images/mobile/android3.png`)
          : require(`../images/mobile/appstore3.png`)
      },
      handleOpen() {
        this.modalVisible = true
      },
      close() {
        this.modalVisible = false
      },
      handleTrackClick( channel) {
        // 埋点
        window.vizier.track_event('download', {
          channel,
          choose: 3,
        })
      },
      showDownloadList() {
        this.downloadListVisible = !this.downloadListVisible
      },
      loseFocus(e) {
        if (e.target.dataset.name !== 'android' && this.downloadListVisible) {
          this.downloadListVisible = false
        }
      },
    },
  }
</script>

<style lang="less">
  .app-main {
    height: 100%;
    overflow-y: scroll;
    .main {
      position: relative;
      .sixteen {
        position: absolute;
        right: 0.2rem;
        top: 0.22rem;
        width: 0.8rem;
        height: 1.08rem;
        background: url(../images/mobile/16.png) no-repeat center;
        background-size: cover;
        pointer-events: none;
      }
      .radio {
        position: absolute;
        left: 0.6rem;
        top: 4.6rem;
        width: 0.9rem;
        height: 0.9rem;
        background: url(../images/mobile/radio.png) no-repeat center;
        background-size: cover;
        pointer-events: none;
      }
      .jumps {
        position: absolute;
        bottom: 2.5rem;
        left: 50%;
        margin-left: -2rem;
        display: flex;
        justify-content: space-between;
        width: 4rem;
        pointer-events: none;
        .item {
          width: 1.1rem;
          height: 1.1rem;
          background-size: cover !important;
        }
        .weibo {
          background: url(../images/mobile/weibo.png) no-repeat center;
        }
        .wechat {
          background: url(../images/mobile/wechat.png) no-repeat center;
        }
        .tap {
          background: url(../images/mobile/taptap.png) no-repeat center;
        }
      }
      .app-load {
        position: absolute;
        bottom: 0.8rem;
        left: 50%;
        margin-left: -2.9rem;
        display: flex;
        justify-content: space-around;
        width: 5.8rem;
        .load {
          width: 2.8rem;
        }
        .secret {
          position: relative;
        }
        a {
          position: relative;
          .download-list {
            padding: 0.15rem 0;
            margin: 0;
            list-style: none;
            position: absolute;
            bottom: 0.8rem;
            width: 3rem;
            background: url(../images/common/download-list-bg.png);
            background-size: 100% 100%;
            li {
              margin: 0.1rem 0.08rem;
              cursor: pointer;
              img {
                width: 2.8rem;
              }
            }
          }
        }
      }
    }
  }
  .show {
    display: block !important;
  }
  .text-tips {
    width: 100%;
    position: absolute;
    bottom: 0.1rem;
    color: #ffffff;
    text-align: center;
    font-size: 0.22rem;
    font-weight: 400;
  }
  .app-footer {
    font-size: 0.14rem;
    color: #fff;
    position: relative;
    background-color: #786de0;
    z-index: 1;
    min-height: 4rem;
    .img {
      position: absolute;
      z-index: -1;
      width: 100%;
      height: 100%;
      display: block;
    }
    .logos {
      display: flex;
      width: 100%;
      justify-content: center;
      align-items: center;
      .logo {
        margin-right: 25px;
        background-size: cover !important;
      }
      .logo1 {
        width: 2rem;
        height: 0.76rem;
        background: url(../images/mobile/logo1.png) no-repeat center;
        margin-right: 0.3rem;
      }
      .logo2 {
        width: 1.6rem;
        height: 0.48rem;
        background: url(../images/mobile/logo2.png) no-repeat center;
      }
    }
    .extra {
      justify-content: center;
    }
    .add-top {
      display: flex;
      margin-bottom: 0.04rem;
      text-align: center;
      // justify-content: left;
      .add-block {
        display: flex;
        margin-left: 0.05rem;
      }
      .add-block:first-child {
        margin-left: 0;
      }
      .add-block:last-child .s-line {
        display: none;
      }
      .s-line {
        width: 0.05rem;
        margin-top: 0.05rem;
        height: 0.15rem;
        border-right: 1px solid #fff;
      }
    }
    a {
      color: #fff;
      text-decoration: none;
    }
  }
  .radioModal {
    position: fixed;
    z-index: 100;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;

    text-align: center;
    font-size: 0.24rem;
    width: 100%;
    background-color: #000;
    .radio-main {
      position: relative;
      height: 100%;
    }
    .close {
      color: #fff;
      position: absolute;
      z-index: 10000000;
      right: 0.1rem;
      top: 50%;
      margin-top: -3.4rem;
      img {
        width: 0.6rem;
      }
      &:hover {
        cursor: pointer;
      }
    }
    .contact {
      position: absolute;
      top: 50%;
      margin-top: -3.5rem;
      background-color: bisque;
      height: 7rem;
      .age-text {
        padding: 0.2rem;
      }
      img {
        margin-top: 0.2rem;
        width: 3rem;
      }
    }
  }
</style>
